import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const bulkSubmitFhirResources = async (apiToken = null, resourceSetString = null, status = 'active', tool = null) => {
    if (!apiToken) {
        console.log("no apiToken");
        return null;
    }
    if (!resourceSetString) {
        console.log("no resourceSetString");
        return null;
    }
    //console.log("CALLING SERVER with bulksubmitfhirresource")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'bulksubmitfhirresource',
            'apiToken': apiToken,
            'resourceSet': resourceSetString,
            'title': "",
            'status': status,
            'tool': tool
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
        }
        console.log("NO RESPONSE from bulksubmitfhirresource call");
    }).catch((error) => { console.log(error); });
};

export default bulkSubmitFhirResources;